module.exports = __webpack_public_path__ + "img/client.2f6517cf.jpg";